import axios from 'axios'
export function request(config) {
    const instance = axios.create({
        baseURL: 'https://api.zbzyuan.com/api',
        timeout: 5000
    })
    instance.interceptors.request.use(config => {
        return config
    }, err => {
        console.log(err)
    })
    instance.interceptors.response.use(res => {
        return res.data
    })
    return instance(config)
}